module.exports = __webpack_public_path__ + "img/地图C-极致高空晚宴.0aaa439d.png";